import React from 'react';

const FacebookRedirectPage: React.FC = () => {
  return <div>FacebookRedirectPage</div>;
};

export default FacebookRedirectPage;
